/**
 * Development-Only Logger Utility
 *
 * Provides console logging functions that only execute in development mode.
 * All console.log/error/warn calls in the app should use these instead
 * of direct console.* calls to prevent sensitive data leakage in production.
 *
 * Usage:
 *   import { devLog, devError, devWarn } from '../../utils/devLogger';
 *   devLog('My debug message:', data);
 *
 * In production (NODE_ENV === 'production'), all calls become no-ops.
 */

const isDev = process.env.NODE_ENV === 'development';

/** Logs a message only in development mode (replaces console.log) */
export const devLog = (...args: any[]): void => {
	if (isDev) {
		console.log(...args);
	}
};

/** Logs an error only in development mode (replaces console.error) */
export const devError = (...args: any[]): void => {
	if (isDev) {
		console.error(...args);
	}
};

/** Logs a warning only in development mode (replaces console.warn) */
export const devWarn = (...args: any[]): void => {
	if (isDev) {
		console.warn(...args);
	}
};

const DevLogger = { devLog, devError, devWarn };
export default DevLogger;
